"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allPayhawkErrors = exports.eErrorCode = void 0;
const dataError_class_1 = __importDefault(require("./dataError.class"));
const payhawk_json_1 = __importDefault(require("./payhawk.json"));
var eErrorCode;
(function (eErrorCode) {
    eErrorCode["UNKNOWN"] = "UNKNOWN";
    eErrorCode["USER_ID_NOT_SET"] = "USIDNS";
    eErrorCode["FREIGHT_ID_NOT_SET"] = "FRIDNS";
    eErrorCode["NAME_NOT_SET"] = "NAMENS";
    eErrorCode["EMAIL_NOT_SET"] = "EMALNS";
    eErrorCode["EMAIL_INVALID"] = "EMALNV";
    eErrorCode["ADDRESS_ADDRESS1_NOT_SET"] = "ADA1NS";
    eErrorCode["ADDRESS_CITY_NOT_SET"] = "ADCTNS";
    eErrorCode["ADDRESS_STATE_NOT_SET"] = "ADSTNS";
    eErrorCode["ADDRESS_POSTAL_NOT_SET"] = "ADPSNS";
    eErrorCode["ADDRESS_COUNTRY_NOT_SET"] = "ADCNNS";
    eErrorCode["TRANSPORT_MODE_NOT_SET"] = "TRMDNS";
    eErrorCode["TRANSPORT_MODE_INVALID"] = "TRMDNV";
    eErrorCode["FROM_COUNTRY_INVALID"] = "FRCNNV";
    eErrorCode["TO_COUNTRY_INVALID"] = "TOCNNV";
    eErrorCode["EQUIPMENT_TYPE_NOT_SET"] = "EQTPNS";
    eErrorCode["OTHER_EQUIPMENT_TYPE_NOT_SET"] = "OEQTNS";
    eErrorCode["RAILWAY_NAME_NOT_SET"] = "RLNMNS";
    eErrorCode["TRAIN_NUMBER_NOT_SET"] = "RNTNNS";
    eErrorCode["AIRLINE_NAME_NOT_SET"] = "ALNMNS";
    eErrorCode["FLIGHT_NUMBER_NOT_SET"] = "ALFNNS";
    eErrorCode["IMO_NOT_SET"] = "MRIMNS";
    eErrorCode["COMMODITY_NOT_SET"] = "CMDTNS";
    eErrorCode["OTHER_COMMODITY_NOT_SET"] = "OCMDNS";
    eErrorCode["UNIT_NOT_SET"] = "WTUUTNS";
    eErrorCode["VALUE_INVALID"] = "WTVLNS";
    eErrorCode["TELEMATICS_PROVIDER_NOT_SET"] = "TLPRNS";
    eErrorCode["PICKUP_DATE_NOT_SET"] = "PKDTNS";
    eErrorCode["DELIVERY_DATE_NOT_SET"] = "DLDTNS";
    eErrorCode["PICKUP_DATE_INVALID"] = "PKDTNV";
    eErrorCode["DELIVERY_DATE_INVALID"] = "DLDTNV";
    eErrorCode["STOPS_INVALID"] = "STPSNV";
    eErrorCode["STOP_INVALID"] = "STOPNV";
    eErrorCode["STOP_TYPE_NOT_SET"] = "STTPNS";
    eErrorCode["PORT_STOP_NAME_NOT_SET"] = "PSNMNS";
    eErrorCode["PORT_STOP_COUNTRY_NOT_SET"] = "PSCNNS";
    eErrorCode["ADDRESS_STOP_ADDRESS_NOT_SET"] = "ASADNS";
    eErrorCode["CARGO_VALUE_NOT_SET"] = "CGVLNS";
    eErrorCode["CARGO_TYPE_INVALID"] = "CGTPNV";
    eErrorCode["PAYMENT_TOKEN_NOT_SET"] = "PMTKNS";
    eErrorCode["CARDHOLDER_NAME_NOT_SET"] = "PMCNNS";
    eErrorCode["ADDRESS_NOT_SET"] = "ADDRNS";
    eErrorCode["CARGO_VALUE_INVALID"] = "CGVLNV";
    eErrorCode["COVERAGE_NOT_AVALABLE"] = "CVRGNA";
    eErrorCode["COVERAGE_LIMIT_UNDER_DEDUCTIBLE"] = "CVRGLUD";
    eErrorCode["COMMODITY_NOT_AVALABLE"] = "CMDTNA";
    eErrorCode["TRUCKLOAD_NOT_AVALABLE"] = "TRLDNA";
    eErrorCode["EQUIPMENT_TYPE_NOT_AVALABLE"] = "EQTPNA";
    eErrorCode["ASSURED_COUNTRY_INVALID"] = "ASCNNV";
    eErrorCode["ASSURED_ADDRESS_INVALID"] = "ASCNNV";
    eErrorCode["STOP_ADDRESS_INVALID"] = "STCSNV";
    eErrorCode["STOP_COUNTRY_INVALID"] = "STCNNV";
    eErrorCode["CARRIER_MODE_NOT_AVALABLE"] = "CRMDNA";
    eErrorCode["STOP_TYPE_NOT_AVALABLE"] = "STTPNA";
    eErrorCode["QUOTE_TOKEN_USED"] = "QTTKUS";
    eErrorCode["QUOTE_TOKEN_NOT_SET"] = "QTTKNS";
    eErrorCode["QUOTE_TOKEN_INVALID"] = "QTTKNV";
    eErrorCode["QUOTE_TOKEN_EXPIRED"] = "QTTKEX";
    eErrorCode["QUOTE_FREIGHT_DUPLICATED"] = "QTFIDD";
    eErrorCode["SHIPPER_NOT_SET"] = "SHPRNS";
    eErrorCode["RECIPIENT_NOT_SET"] = "RCPTNS";
    eErrorCode["CARGO_CONTAINERIZATION_NOT_SET"] = "CGCNNS";
    eErrorCode["CARGO_PACKAGING_NOT_SET"] = "CGPKNS";
    eErrorCode["CARGO_TERMS_OF_SALE_NOT_SET"] = "CGTSNS";
    eErrorCode["KYC_ERROR"] = "KYCERR";
    eErrorCode["DATA_VALIDATION_ERROR"] = "DTVLER";
    eErrorCode["SALESFORCE_NAME_DUPLICATE"] = "SFND";
})(eErrorCode = exports.eErrorCode || (exports.eErrorCode = {}));
exports.allPayhawkErrors = payhawk_json_1.default.map((error) => ({
    code: error.code,
    message: error.message
}));
exports.default = dataError_class_1.default;
//# sourceMappingURL=index.js.map